import { Component, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { fadeInRight400ms } from 'src/@core/animations/fade-in-right.animation';
import { fadeInUp400ms } from 'src/@core/animations/fade-in-up.animation';
import { stagger40ms } from 'src/@core/animations/stagger.animation';
import { permissions } from 'src/app/shared/helpers/roles-permissions';
import { EnterpriseAdminService } from '../enterprise-admin/enterprise-admin.service';
import { AppService } from 'src/@core/services/app.service';

@Component({
  selector: 'hour4u-admin-agents',
  templateUrl: './agents.component.html',
  styleUrls: ['./agents.component.scss'],
  animations: [
    fadeInUp400ms,
    stagger40ms,
    fadeInRight400ms
  ],
})
export class AgentsComponent implements OnInit {
  permissions = permissions;
  profile = this.appService.getCurrentAccount();
  agents: any[] = [];
  isLoading: boolean = false;
  diameter = 40;
  loaderColor: string;
  mode = 'indeterminate';
  pageIndex: number = 1;
  pageSize: number = 10;
  pageSizeOptions: number[] = [10, 20, 50, 100, 200, 500];
  currentRange: string = '';
  pagination: any = null;

  constructor(private router: Router, public enterpriseAdminService: EnterpriseAdminService, private appService: AppService) { }

  ngOnInit() {
    this.getAllAgent()
  }

  createAgent() {
    this.router.navigate([`/agents/agent-create`]);
  }

  goToAgent(agent_id: string) {
    this.router.navigate([`/agents/agent-view`, agent_id]);
  }

  getAllAgent() {
    this.isLoading = true;
    const entityId = this.profile.entity.id;

    if (!entityId) {
      console.error('Entity ID is missing!');
      this.isLoading = false;
      return;
    }

    this.agents = [];

    this.enterpriseAdminService.getAllAgentsByEntityId(entityId, this.pageSize, this.pageIndex).subscribe(
      (response) => {
        console.log('response retrieved successfully:', response);

        // Add profilePic key to each agent
        this.agents = response.items.map(agent => ({
          ...agent,
          profilePic: '/assets/agent-dp.webp'
        }));
        console.log('Agents retrieved successfully:', this.agents);

        this.pagination = response.pagination;
        this.updateRange();
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
        console.error('Failed to fetch agents:', error);
      }
    );
  }

  onNext() {
    if (this.pagination && this.pagination.currentPageNum < this.pagination.totalPages) {
      this.pagination.currentPageNum += 1;
      this.getAllAgent();
    }
  }

  onPrev() {
    if (this.pagination && this.pagination.currentPageNum > 1) {
      this.pagination.currentPageNum -= 1;
      this.getAllAgent();
    }
  }

  updateRange() {
    if (this.pagination && this.pagination.currentPageNum && this.pagination.currentPageSize && this.pagination.totalElements) {
      const start = (this.pagination.currentPageNum - 1) * this.pagination.currentPageSize + 1;
      const end = Math.min(this.pagination.currentPageNum * this.pagination.currentPageSize, this.pagination.totalElements);
      this.currentRange = `${start} - ${end} of ${this.pagination.totalElements} records`;
    } else {
      this.currentRange = '0 - 0 of 0 records'; // Default value in case pagination is not valid
    }
  }

  onPageSizeChange(value: any) {
    const newSize = parseInt(value, 10);
    this.pageSize = newSize;
    this.pagination.currentPageSize = this.pageSize;
    this.pagination.currentPageNum = 1; // Reset to the first page after size change
    this.updateRange();
    this.getAllAgent();
  }
}